import Vue from "vue";
import Component from "vue-class-component";
import ClientsDebtTable from "@/components/ClientsDebtTable/ClientsDebtTable"
import { FilterParams } from '@/types/filter';
import REQ_URL from '@/consts/req-url';
import { ClientsDebtList } from '@/types/client-debt';
import { modalParams } from '@/types/state.modal';
import isIntoView from '@/api/isIntoView';
@Component({
    components: {
        ClientsDebtTable
    }
})
export default class ClientsDebtContainer extends Vue {
    loading = true
    pageInfoPrev = {
        curr: 1,
        of: 1
    }
    pageInfo = {
        curr: 1,
        of: 1
    }
    filterParams = {
        search: ''
    }
    clientDebtList: ClientsDebtList = []
    get pageVisible() {
        return this.$vuetify.breakpoint.xsOnly ? 6 : 7
    }
    async filtering(needScroll = false) {
        this.loading = true
        try {
            let data = await this.$fetch<ClientsDebtList>(REQ_URL.GET_CLIENTS_DEBT, {
                method: 'GET',
                /*body: JSON.stringify({
                    filterParams: this.filterParams,
                })*/
            })
            if (data.body) {
                this.clientDebtList = data.body
                if (needScroll) {
                    let tb = document.getElementById('toolbar')
                    if (tb && !isIntoView('#clients-debt')) {
                        this.$vuetify.goTo('#clients-debt', {
                            duration: 300,
                            offset: (tb && tb.offsetHeight ? tb.offsetHeight : 0) + 30,
                            //easing: this.easing
                        })
                    }
                }
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            this.pageInfo.curr = this.pageInfoPrev.curr
            this.pageInfo.of = this.pageInfoPrev.of

            let errMsg: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', errMsg)
        }
        this.loading = false
    }
    updateFilterParams(e: FilterParams) {
        this.filterParams = e
        this.pageInfo.curr = 1
        this.filtering()
    }
    /*updatePage(e: number) {
        this.pageInfo.curr = e;
        this.filtering(true)
    }*/
    mounted() {
        this.filtering();
    }
}